module.exports = __webpack_public_path__ + "1.5.0-unryo/img/tomcat.83978bf7.svg";